module.exports = __webpack_public_path__ + "static/media/hidrotermal.96b86830.jpg";